// extracted by mini-css-extract-plugin
export default {"link":"link--JJuks","text-block":"text-block--Gqqwz","textBlock":"text-block--Gqqwz","title":"title--BtonJ","blurb":"blurb--Rb+oW"};